module.exports = __webpack_public_path__ + "img/ypo-renewals-stage-3.5c2ea754.png";